import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Código del Silencio Digestivo',
    items: ['Qué es el SIBO y los 3 tipos', 'El MMC (complejo motor migrante)', 'Los 12 síntomas que nadie conecta', 'Diagnóstico Personal con plan de acción', 'Plan para los primeros 3 días'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — La Alacena Sanadora',
    items: ['Las 3 Cajas del sistema alimentario', 'Semáforo FODMAP Argentino completo', 'Reemplazos 1:1 para cada alimento que pausás', 'Lista de compras lista para imprimir', 'Versión para guardar en el celular'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — Cocina de Rescate',
    items: ['15 desayunos + 15 almuerzos anti-SIBO', 'Ingredientes de tu feria', 'El Método de 20 Minutos', 'El truco del enfriado', '6 aderezos que curan mientras condimentan'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Reparación Nocturna',
    items: ['15 cenas anti-SIBO', 'Protocolo 12:12 de ayuno suave', '8 infusiones medicinales por síntoma', 'Tracker nocturno de 7 indicadores'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — El Plan de Vida Libre',
    items: ['Calendario integrado de 14 días', 'Protocolo de Reintroducción', '5 suplementos con evidencia (disponibles en Argentina)', 'La Regla del 80/20 para sostener el resultado'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Plan diario listo para arrancar hoy mismo', 'Recetas y preparaciones paso a paso', 'Semáforo FODMAP adaptado a Argentina', 'Tracker de síntomas + criterios de medición', 'Errores frecuentes y cómo evitarlos', 'Checklist imprimible por etapa', '100% adaptado a la mujer argentina'];
  return <section className="py-24 bg-brand-dark" data-id="element-225">
      <div className="container mx-auto px-4" data-id="element-226">
        <div className="max-w-5xl mx-auto" data-id="element-227">
          <div className="text-center mb-16" data-id="element-228">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-229">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-230">
                🏆 PROTOCOLO RESCATE SIBO™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-231">
                Tu hoja de ruta definitiva de 14 días para recuperar el
                bienestar.
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-232">
            📚 5 TOMOS COMPLETOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-233">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-234">
                <div className="text-5xl shrink-0" data-id="element-235">{tomo.emoji}</div>
                <div data-id="element-236">
                  <h4 className="text-xl font-bold text-white mb-3" data-id="element-237">
                    {tomo.title}
                  </h4>
                  <ul className="space-y-2" data-id="element-238">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-239">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-240" />
                        <span data-id="element-241">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-242">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-243">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-244">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-245">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-246" />
                  <span className="text-gray-200" data-id="element-247">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}